<template>
  <CBox :bg="['#F1F2F4', 'var(--colors-light-primary-light-gray)']" minHeight="100vh" width="100vw" position="sticky">
    <OmtLayoutContainer :bg="['#F1F2F4', '#FFFF']">
      <template v-if="hydrated || hydrating">
        <OmtRow
          class="affiliate-ai-entry-row"
          :mt="['-24px', '-40px']"
          :mx="['-16px', '-40px']"
          :px="['16px', '24px']"
          :pt="['20px', '24px']"
          :pb="['16px', '0']"
        >
          <CBox class="affiliate-ai-entry" data-tour="busca-rede-home-search">
            <CFlex class="affiliate-ai-entry__title">
              <OmtIcons name="sparkles" color="#172972" size="1x" />
              <OmtTypography as="h3-bold" class="affiliate-ai-entry__title-text">Assistente Omint</OmtTypography>
              <CBox as="span" class="affiliate-ai-entry__badge">IA</CBox>
            </CFlex>

            <OmtTypography as="p1" class="affiliate-ai-entry__description">
              Descreva o que você precisa e o assistente encontra o médico, laboratório ou hospital na sua rede.
            </OmtTypography>

            <CFlex as="form" class="affiliate-ai-entry__form" @submit.prevent="submitAiSearch">
              <input
                v-model="aiQuestion"
                class="affiliate-ai-entry__input"
                type="text"
                placeholder="Ex.: cardiologista perto de mim"
              />
              <CBox as="button" type="submit" class="affiliate-ai-entry__submit" aria-label="Enviar pergunta">
                <OmtIcons name="arrow-right" color="#FFFFFF" size="1x" />
              </CBox>
            </CFlex>

            <CFlex :display="['none', 'flex']" class="affiliate-ai-entry__suggestions">
              <CBox
                v-for="suggestion in aiSuggestions"
                :key="suggestion"
                as="button"
                type="button"
                class="affiliate-ai-entry__suggestion"
                @click="submitAiSuggestion(suggestion)"
              >
                {{ suggestion }}
              </CBox>
            </CFlex>

            <CBox as="span" class="affiliate-ai-entry__beta">beta</CBox>
          </CBox>
        </OmtRow>
      </template>

      <OmtRow data-tour="busca-rede-categorias" stack :mx="['-16px', '-40px']">
        <template v-if="hydrated || hydrating">
          <OmtRow :px="['16px', '24px']" mt="24px">
            <CFlex class="affiliate-structured-divider">
              <CBox class="affiliate-structured-divider__line" />
              <OmtTypography as="p2" class="affiliate-structured-divider__text">ou busque você mesmo</OmtTypography>
              <CBox class="affiliate-structured-divider__line" />
            </CFlex>
          </OmtRow>
        </template>

        <template v-else>
          <OmtRow mb="16px" :px="['16px', '24px']">
            <OmtSelect placeholder="Selecione um plano" @change="e => setPlano(e)" mb="24px" :initialValue="plano">
              <option v-for="(p, index) in planos" :key="`${p.Codigo}-${index}`" :value="p.Codigo">
                {{ p.Codigo }}
              </option>
            </OmtSelect>
          </OmtRow>
          <OmtRow mb="16px" :px="['16px', '24px']">
            <OmtSelect placeholder="Ou selecione uma rede" @change="e => setRede(e)" mb="24px" :initialValue="rede">
              <option v-for="(r, index) in redes" :key="`${r.Codigo}-${index}`" :value="r.Codigo">
                {{ r.Descricao }}
              </option>
            </OmtSelect>
          </OmtRow>
        </template>

        <OmtRow
          :mt="['0px', '24px']"
          :px="['16px', '24px']"
          :py="['16px', '24px']"
          :bg="['#F1F2F4', '#FFFF']"
          :borderRadius="['0', '8px']"
          v-if="loaded && !hasHomeItems"
        >
          <CBox bg="#FFFFFF" border-radius="8px" p="16px" w="100%">
            <CFlex direction="column" align="center" text-align="center">
              <OmtTypography as="h3-bold" font-size="16px" color="#4E4E4E" line-height="24px" mb="8px">
                Nenhum item disponível
              </OmtTypography>
              <OmtTypography as="p1" font-size="14px" font-weight="400" color="#4E4E4E" line-height="20px">
                No momento, não há informações ou categorias disponíveis para exibição.
              </OmtTypography>
            </CFlex>
          </CBox>
        </OmtRow>

        <OmtRow
          :mt="['0px', '24px']"
          :px="['16px', '24px']"
          :py="['16px', '24px']"
          :bg="['#F1F2F4', '#FFFF']"
          :borderRadius="['0', '8px']"
          v-else
        >
          <CBox
            v-if="loaded"
            display="grid"
            :grid-template-columns="['repeat(3, minmax(0, 1fr))', 'repeat(5, minmax(0, 1fr))']"
            grid-gap="16px"
            width="100%"
          >
            <CBox
              v-for="(tile, index) in categoryTiles"
              :key="index"
              @click="onTileClick(tile)"
              cursor="pointer"
              border="0.5px solid var(--colors-light-secondary-divider)"
              border-radius="8px"
              px="8px"
              py="16px"
              display="flex"
              flex-direction="column"
              bg="#FFFFFF"
              :maxW="'100%'"
            >
              <CFlex align-items="center" justify-content="space-between" mb="16px">
                <img
                  v-if="tile.Codigo === 'hospital'"
                  :src="baseUrl + '/images/omint/hospitals.svg'"
                  alt="Hospital"
                  style="width: 1em; height: 1em"
                />
                <OmtIcons v-else :name="getIconName(tile.Codigo)" size="1x" />
              </CFlex>
              <OmtTypography as="p1"> {{ tile.title }} </OmtTypography>
            </CBox>
          </CBox>
        </OmtRow>
      </OmtRow>

      <template v-if="hasHomeItems">
        <OmtRow
          :mt="['0', '24px']"
          :mx="['-16px', '-40px']"
          v-if="homeRecommendations.length"
          :bg="['#F1F2F4', '#FFFF']"
          px="24px"
          :py="['8px', '24px']"
          :borderRadius="['0', '8px']"
        >
          <CBox>
            <OmtTypography as="l2">Recomendações</OmtTypography>
            <CBox mt="16px" display="flex" flex-wrap="wrap">
              <CBox
                bg="#FFFFFF"
                v-for="(recommendation, index) in homeRecommendations"
                :key="`recommendation-${index}`"
                cursor="pointer"
                mr="8px"
                mb="8px"
                width="fit-content"
                border-radius="40px"
                px="16px"
                py="4px"
                border="0.5px solid var(--colors-light-secondary-divider)"
                @click="handleRecommendation(recommendation)"
                :data-tour="isFavoritosRecommendation(recommendation) ? 'busca-rede-favoritos' : undefined"
              >
                <OmtTypography as="p1">{{ recommendation.Titulo }}</OmtTypography>
              </CBox>
            </CBox>
          </CBox>
        </OmtRow>

        <OmtRow
          mt="24px"
          :desktopStart="5"
          :desktopEnd="8"
          v-if="loaded && (hydrated || hydrating)"
          @click="setDeactivated"
          cursor="pointer"
        >
          <OmtTypography as="p1" text-decoration="underline">
            Consultar credenciados <span v-show="deactivated">ativos</span><span v-show="!deactivated">inativos</span>
          </OmtTypography>
        </OmtRow>
      </template>

      <ModalSearchAddress :is-open="showLocationModal" @close="closeLocationModal" @select="handleAddressSelection" />

      <ModalSearchOtherAddress
        :is-open="showOtherAddressModal"
        @close="closeOtherAddressModal"
        @apply="handleOtherAddressSelection"
      />

      <Onboard v-if="shouldOpenOnboard" onboard="affiliate-search-onboard" />
    </OmtLayoutContainer>
  </CBox>
</template>

<script>
import LocationCard from "@/components/Organisms/AffiliateSearch/LocationCard";
import ModalSearchAddress from "@/components/Organisms/AffiliateSearch/ModalSearchAddress";
import ModalSearchOtherAddress from "@/components/Organisms/AffiliateSearch/ModalSearchOtherAddress";
import { capitalizeWords } from "@/utils/utils";
import { maybeResumeBuscaRedeTourOnAffiliateHome } from "@/utils/buscaRedeTour";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "AffiliateHome",
  components: {
    ModalSearchAddress,
    ModalSearchOtherAddress,
    LocationCard
  },
  data() {
    return {
      aiQuestion: "",
      aiSuggestions: ["Preciso de um cardiologista", "Dermatologista", "Pediatra"],
      loaded: false,
      showLocationModal: false,
      showOtherAddressModal: false
    };
  },
  computed: {
    ...mapGetters("saude", ["baseUrl"]),
    ...mapState("saude", ["hydrated", "hydrating"]),
    ...mapState("affiliate", [
      "homeCategories",
      "homeRecommendations",
      "enderecoSelecionado",
      "locationDisabled",
      "plano",
      "planos",
      "rede",
      "redes",
      "deactivated",
      "title"
    ]),
    hasHomeItems() {
      return (
        (this.categoryTiles && this.categoryTiles.length > 0) ||
        (this.homeRecommendations && this.homeRecommendations.length > 0)
      );
    },
    locationTitle() {
      if (this.enderecoSelecionado) {
        if (
          (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual") &&
          this.enderecoSelecionado.Titulo
        ) {
          return this.enderecoSelecionado.Titulo;
        }
        return this.enderecoSelecionado.Titulo || "Localização";
      }
      return "Localização";
    },
    locationSubtitle() {
      if (this.enderecoSelecionado) {
        if (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual") {
          return "Buscando pela sua localização atual";
        }
        return this.enderecoSelecionado.Descricao || this.formatLocationSubtitle(this.enderecoSelecionado);
      }
      return "";
    },
    isCurrentLocationDisabled() {
      if (!this.locationDisabled) return false;

      const isEnderecoAtual =
        this.enderecoSelecionado &&
        (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual");

      return !!isEnderecoAtual;
    },
    categoryTiles() {
      return [...this.homeCategories]
        .sort((a, b) => (a.Ordem ?? 0) - (b.Ordem ?? 0))
        .map(category => ({
          title: capitalizeWords(category.Titulo),
          icon: category.Icone,
          ...category
        }));
    }
  },
  methods: {
    ...mapMutations("affiliate", [
      "SET_LOCATION_TYPE",
      "SET_DEACTIVATED",
      "SET_TIPO_ATENDIMENTO",
      "SET_REDE",
      "SET_PLANO",
      "SET_GROUP",
      "SET_ENDERECO_SELECIONADO"
    ]),
    ...mapActions("affiliate", ["fetchGroups", "reset", "getAddressSearch", "requestUserLocation"]),
    isFavoritosRecommendation(recommendation) {
      const codigo = String(recommendation?.TipoAcao || "").toLowerCase();
      const titulo = String(recommendation?.Titulo || "").toLowerCase();
      return codigo === "favoritos" || codigo === "seus-favoritos" || titulo.includes("favorito");
    },
    submitAiSearch() {
      this.goToAiChat(this.aiQuestion);
    },
    submitAiSuggestion(suggestion) {
      this.goToAiChat(suggestion);
    },
    goToAiChat(question) {
      const pergunta = `${question || ""}`.trim();
      if (!pergunta) return;

      this.$router.push({
        name: "redecredenciada-prototipo.chat",
        query: { pergunta }
      });
    },
    async handleRecommendation(recommendation) {
      const codigo = (recommendation.TipoAcao || "").toLowerCase();

      switch (codigo) {
        case "indicacao-medica":
          this.requestMedicalIndication();
          break;
        case "favoritos":
        case "seus-favoritos":
          this.SET_LOCATION_TYPE("Favoritos");
          this.$router.push({ name: "affiliate.docs", params: { isFavoritos: true } });
          break;
        default:
          this.$toast({
            description: "Recomendação indisponível no momento.",
            status: "info",
            duration: 8000,
            position: "top"
          });
          break;
      }
    },
    setDeactivated() {
      this.SET_DEACTIVATED(!this.deactivated);
      this.setTitle();
    },
    setTitle() {
      this.$root.$emit("change-title-label", this.title);
    },
    setPlano(e) {
      this.SET_REDE("");
      this.SET_PLANO(e);
      this.fetchGroups();
    },
    setRede(e) {
      this.SET_REDE(e);
      this.SET_PLANO("");
      this.fetchGroups();
    },
    onTileClick(item) {
      const codigoRede = item.Rede ?? item.CodigoRede ?? item.codigoRede ?? item.CdRede ?? "";
      const tipoView = item.Codigo ?? item.TipoView ?? "";
      const descricao = item.Titulo ?? item.DescricaoTipoAtendimento ?? "";

      this.SET_REDE(codigoRede);
      this.SET_TIPO_ATENDIMENTO(tipoView);
      this.SET_GROUP(descricao);
      this.SET_LOCATION_TYPE("");
      this.$router.push({ name: "affiliate.specs" });
    },
    getIconName(TipoView) {
      switch (TipoView) {
        case "pronto-atendimento":
          return "hospital";
        case "medicos-clinicas":
          return "stethoscope";
        case "prontsoc":
          return "hospital";
        case "mediclin":
          return "stethoscope";
        case "laborato":
          return "flask";
        case "pshospital":
          return "baby-carriage";
        case "hospital":
          return "hospitals";
        case "dentclin":
          return "tooth";
        case "terapia":
          return "user-doctor";
        case "vacinas":
          return "syringe";
        default:
          return "hospital";
      }
    },
    capitalizeWords(inputString) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();
    },
    normalize(value) {
      return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    formatLocationSubtitle(location) {
      if (location.Descricao) return location.Descricao;
      if (location.Endereco) return location.Endereco;
      const cityState = [location.Cidade, location.Uf].filter(Boolean).join("/");
      return [cityState, location.Cep].filter(Boolean).join(" - ");
    },
    onLocationClick() {
      this.showLocationModal = true;
    },
    closeLocationModal() {
      this.showLocationModal = false;
    },
    openOtherAddressModal() {
      this.showOtherAddressModal = true;
    },
    closeOtherAddressModal() {
      this.showOtherAddressModal = false;
    },
    async handleAddressSelection(payload) {
      if (payload?.type === "outra-cidade") {
        await this.$root.$emit("show-loading");
        try {
          await this.$store.dispatch("affiliate/fetchStatesNetwork");
          this.closeLocationModal();
          this.openOtherAddressModal();
        } finally {
          await this.$root.$emit("hide-loading");
        }
        return;
      }

      this.SET_ENDERECO_SELECIONADO(payload?.data || null);
      this.closeLocationModal();
    },
    handleOtherAddressSelection(payload) {
      if (payload?.type === "outra-cidade-selecionada") {
        this.SET_ENDERECO_SELECIONADO({
          ...payload.data,
          Tipo: "outra-cidade-selecionada"
        });
      }
    },
    requestMedicalIndication() {
      this.$router.push({ name: "indication" });
    }
  },
  async mounted() {
    try {
      // Busca credenciada
      this.$root.$emit("change-back-route", "/");
      await this.setTitle();
      this.$root.$emit("show-loading");
      await this.reset();

      // Disparamos a busca de grupos, endereços e o prompt de localização em paralelo
      await Promise.all([this.fetchGroups(), this.getAddressSearch(), this.requestUserLocation()]);

      // Após o carregamento, se não tiver endereçoSelecionado e a localização estiver desabilitada,
      // força a seleção da primeira opção salva válida
      if (this.$store.state.affiliate.locationDisabled) {
        const hasCurrentAsSelected =
          this.enderecoSelecionado &&
          (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual");

        if (hasCurrentAsSelected) {
          const addresses = this.$store.state.affiliate.addresses || [];
          const savedAddresses = addresses.filter(endereco => endereco.Tipo !== "atual");
          const fallbackAddress = savedAddresses.find(addr => addr.Tipo !== "outra-cidade") || savedAddresses[0];

          if (fallbackAddress) {
            this.SET_ENDERECO_SELECIONADO(fallbackAddress);
          }
        }
      }
    } finally {
      this.loaded = true;
      this.$root.$emit("hide-loading");
      this.$nextTick(() => {
        maybeResumeBuscaRedeTourOnAffiliateHome(this);
      });
    }
  },
  destroyed() {
    this.$root.$emit("change-back-route", null);
  }
};
</script>

<style scoped>
.affiliate-ai-entry-row {
  background: #f1f2f4;
}

.affiliate-ai-entry {
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 16px;
  background: #ffffff;
  border: 1.5px solid #172972;
  border-radius: 12px;
}

.affiliate-ai-entry__title {
  align-items: center;
  gap: 8px;
  width: 100%;
  background: #ffffff;
}

.affiliate-ai-entry__title-text {
  color: #172972;
}

.affiliate-ai-entry__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 3px 8px;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  background: #172972;
  border-radius: 10px;
}

.affiliate-ai-entry__description {
  color: #6b6b75;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
}

.affiliate-ai-entry__form {
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 52px;
  padding: 10px 10px 10px 14px;
  background: #f6f6f9;
  border-radius: 8px;
}

.affiliate-ai-entry__input {
  flex: 1;
  min-width: 0;
  height: 19px;
  color: #4e4e4e;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  background: transparent;
  border: 0;
  outline: 0;
}

.affiliate-ai-entry__input::placeholder {
  color: #8c8c94;
}

.affiliate-ai-entry__submit {
  display: inline-flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 8px;
  background: #172972;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
}

.affiliate-ai-entry__suggestions {
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.affiliate-ai-entry__suggestion {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 6px 12px;
  color: #4e4e4e;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  background: #ffffff;
  border: 1px solid #d4d6e0;
  border-radius: 16px;
  cursor: pointer;
}

.affiliate-ai-entry__beta {
  position: absolute;
  left: calc(50% - 37px / 2 - 0.5px);
  bottom: -9px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 37px;
  height: 18px;
  padding: 0 8px;
  color: #ffffff;
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 18px;
  background: #1ca0ff;
  border-radius: 32px;
}

.affiliate-structured-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 16px;
  background: transparent;
}

.affiliate-structured-divider__line {
  flex: 1;
  height: 1px;
  background: #dcdde3;
}

.affiliate-structured-divider__text {
  flex: 0 0 auto;
  color: #6b6b75;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
</style>
